import React from 'react';
import {useDesktop, useMobile} from 'src/theme/responsive';

type Props = {
    children: React.ReactNode;
    mobile?: boolean;
    desktop?: boolean;
    [key: string]: any;
}

/**
 * A component that conditionally displays its children based on the screen size.
 */
export default function Responsive({ children, mobile, desktop, ...props }: Props) {
    const isMobileQuery = useMobile();
    const isDesktopQuery = useDesktop();

    if (React.Children.count(children) !== 1) {
        throw new Error('Responsive component must have exactly one child');
    }

    const child = React.Children.only(children);

    if (!React.isValidElement(child)) {
        throw new Error('Responsive component must have a valid child');
    }

    if ((mobile && isMobileQuery) || (desktop && isDesktopQuery)) {
        return React.cloneElement(child, props);
    }

    return null;
}
